import type { IApplicationInsights } from "@microsoft/applicationinsights-web";

// Extend window.appInsights safely
declare global {
    interface Window {
        appInsights?: IApplicationInsights;
    }
}

let pageStart = Date.now();
let maxScroll = 0;
let hasFlushed = false; // debounce guard

function flushMetrics() {
    if (hasFlushed) return;
    hasFlushed = true;

    const ai = window.appInsights;
    if (!ai) return;

    const duration = Date.now() - pageStart;

    ai.trackMetric(
        { name: "Time on Page", average: duration },
        { pageName: window.location.pathname }
    );

    ai.trackMetric(
        { name: "Max Scroll Depth", average: maxScroll },
        { pageName: window.location.pathname }
    );

    ai.flush();
}

function initAppInsightsTracking() {
    const ai = window.appInsights;
    if (!ai) return;

    // Update max scroll depth as user scrolls
    window.addEventListener("scroll", () => {
        const scrolled = Math.round(
            ((window.scrollY + window.innerHeight) / document.body.scrollHeight) * 100
        );
        maxScroll = Math.max(maxScroll, scrolled);
    });

    // Trigger metrics once when the page is unloading (best-effort)
    window.addEventListener("beforeunload", flushMetrics);

    // Backup flush for SPA or hidden tab scenarios
    document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "hidden") {
            flushMetrics();
        }
    });
}

initAppInsightsTracking();
